/** Хэвлэдэг баримтууд (хүргэлтийн, буцаалтын) дээрх байгууллагын нэр ба тамга. */
export const RECEIPT_BUSINESS_NAME = 'Шеф Про ХХК';

/** `public/` доторх тамганы зураг. */
export const RECEIPT_SEAL_IMAGE_URL = '/chef-pro-seal.png';
